export const EXPIRED = 600000 // 10min
export const CACHE_KEY = 'FAVORITES_CACHE'
export const FAVORITES_LIST_KEY = 'favorites'
export const ENDPOINT = '/ws-favorites/favorites/v1/favorites'
export const CUSTOMER_TOKEN_KEY = 'customerToken'
export const DIFF_TIMESTAMP = 1800000 // 30min
export const FAVORITES_LIMIT = 200
